// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__Rli7a","rootSuccess":"CompleteLink_rootSuccess__17nr6","rootFailure":"CompleteLink_rootFailure__3aeU8","isDisabled":"CompleteLink_isDisabled__1nEiN"};